import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _isNil from "lodash/isNil";
import _cloneDeep from "lodash/cloneDeep";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import analytics from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { CheckboxOption } from '@nerdwallet/react-checkbox';
import * as actions from '../../redux/actions';
var DEFAULT_COMPARE_ENTITY_NAME = 'product_card_compare';
var InteractionLocation = 'compare-card-checkbox';
/**
 * KetoCompareCardCheckBox
 * checkbox component(desktop and mobile) to be used for the Keto cards
 *
 * @component
 * @example
 * <KetoCompareCardCheckBox
 *    card: {},
 *    compareCards: {
 *      cardIDsToCompare: [],
 *    }
 *  />
 */

export var KetoCompareCardCheckBox = /*#__PURE__*/function (_React$Component) {
  _inherits(KetoCompareCardCheckBox, _React$Component);

  var _super = _createSuper(KetoCompareCardCheckBox);

  /*
  * Used to set default values for the props argument
  * @defaultProps
  */

  /*
  * @constructor
  */
  function KetoCompareCardCheckBox(props) {
    var _this;

    _classCallCheck(this, KetoCompareCardCheckBox);

    _this = _super.call(this, props);
    _this.handleCompareCardChange = _this.handleCompareCardChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
  * Onchange handler for the keto-checkbox if not passed in by the consumer
  * as a handleCompare prop.
  * @param {object} e  emitted event object
  * @param {unknown} addCardOverride
  *
  * @return {undefined}
  */


  _createClass(KetoCompareCardCheckBox, [{
    key: "handleCompareCardChange",
    value: function handleCompareCardChange(e, addCardOverride) {
      // if the event checked is true, invoke saveToCompare to add the card in the compare bar
      // to make the card available for comparison. If the event checked is false,
      // remove it from the compare bar
      if (e && e.target.checked || addCardOverride) {
        // Set a flag denoting we need to fetch more compare data
        var cardToAdd = _cloneDeep(this.props.card);

        cardToAdd.fetchCompareData = true;
        this.props.saveToCompare({
          cards: [cardToAdd],
          productLocation: InteractionLocation
        });
      } else {
        this.props.removeFromCompare(this.props.card.id, InteractionLocation);
      }
    }
    /*
    * Render the component
    */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleCompare = _this$props.handleCompare,
          showCheckboxLabel = _this$props.showCheckboxLabel,
          checkboxLabel = _this$props.checkboxLabel,
          isSelectedToCompare = _this$props.isSelectedToCompare,
          compareCards = _this$props.compareCards,
          card = _this$props.card; // get all the added cardIds from the compare bar

      var cardIDsToCompare = (compareCards === null || compareCards === void 0 ? void 0 : compareCards.cardIDsToCompare) || []; // if the boolean isSelectedToCompare is defined (true/false)
      // we will use the value, if not we will check cardIDsToCompare
      // the current card id already added in the
      // cardIDsToCompare; then display the checkbox checked=true

      var isInCompare = !_isNil(isSelectedToCompare) ? isSelectedToCompare : cardIDsToCompare.indexOf(_get(card, 'id', null)) > -1; // use handleCompareCardChange for onChange if the consumer did not pass the handleCompare prop

      var onChange = handleCompare || this.handleCompareCardChange; // if the uncheckedText or checkedText is undefined or an empty string
      // then use the default value else use the value passed in by the consumer

      var uncheckedText = checkboxLabel && checkboxLabel.uncheckedText || "Add to compare";
      var checkedText = checkboxLabel && checkboxLabel.checkedText || "Added to compare"; // if showCheckboxLabel=true, display the checkbox label, as per checked={true/false}
      // else display empty string

      var label = "";
      if (showCheckboxLabel) label = isInCompare ? checkedText : uncheckedText; // isInCompare param accounts for the handleCompareClick function to
      // decide whether to call the saveToCompare or removeFromCompare

      var clickHandler = function clickHandler(impressionId) {
        var _this2$props$analytic;

        if ((_this2$props$analytic = _this2.props.analytics) !== null && _this2$props$analytic !== void 0 && _this2$props$analytic.enabled || _this2.props.enableAnalytics) {
          var _this2$props$analytic2, _this2$props$analytic3;

          var elementInteractedPayload = {
            entity_name: (_this2$props$analytic2 = (_this2$props$analytic3 = _this2.props.analytics) === null || _this2$props$analytic3 === void 0 ? void 0 : _this2$props$analytic3.entityName) !== null && _this2$props$analytic2 !== void 0 ? _this2$props$analytic2 : DEFAULT_COMPARE_ENTITY_NAME,
            action: isInCompare ? 'unselect' : 'select',
            interaction_type: 'press'
          };

          if (impressionId) {
            elementInteractedPayload.impression_id = impressionId;
          }

          analytics.track('element_interacted', elementInteractedPayload);
        }

        onChange(null, !isInCompare, card === null || card === void 0 ? void 0 : card.offerId);
      };

      return /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement("div", {
          className: "keto-compare-checkbox"
        }, /*#__PURE__*/React.createElement(CheckboxOption, {
          className: "input",
          label: label,
          checked: isInCompare,
          onChange: function onChange() {
            return clickHandler(value === null || value === void 0 ? void 0 : value.impressionId);
          },
          inline: true
        }));
      });
    }
  }]);

  return KetoCompareCardCheckBox;
}(React.Component);
/**
 * The mapStateToProps function to use for the connected component
 */

_defineProperty(KetoCompareCardCheckBox, "propTypes", {
  /*
  * Card object containing the card id rendering the checkbox
  */
  card: PropTypes.shape({
    /*
    * Legacy ID
    */
    id: PropTypes.number,

    /*
    * Offer ID
    */
    offerId: PropTypes.string
  }).isRequired,

  /*
  *  **DEPRECATED**: Whether we want to send bedrock analytics events
  */
  enableAnalytics: PropTypes.bool,

  /*
  * Whether we want to send bedrock analytics events
  */
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    entityName: PropTypes.string
  }),

  /*
  * Onchange handler for the checkbox
  */
  handleCompare: PropTypes.func,

  /*
  * Function to invoke when the checkbox is checked to add the card in the compare bar
  */
  saveToCompare: PropTypes.func.isRequired,

  /*
  * Function to invoke when the checkbox is unchecked to remove the card from the compare bar
  */
  removeFromCompare: PropTypes.func.isRequired,

  /*
  * Checkbox label
  */
  checkboxLabel: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /*
  * Display Checkbox label, {true when in desktop/false when in mobile}
  */
  showCheckboxLabel: PropTypes.bool,

  /*
  * Determine if checkbox is selected to compare
  */
  isSelectedToCompare: PropTypes.bool,

  /*
  * All cards in compare bar
  */
  compareCards: PropTypes.shape({
    cardIDsToCompare: PropTypes.arrayOf(PropTypes.number)
  })
});

_defineProperty(KetoCompareCardCheckBox, "defaultProps", {
  analytics: {
    enabled: false,
    entityName: 'product_card_compare'
  },
  checkboxLabel: {
    uncheckedText: "Add to Compare",
    checkedText: "Added to Compare"
  },
  enableAnalytics: false,
  showCheckboxLabel: true
});

export var mapStateToProps = function mapStateToProps(_ref) {
  var compareCards = _ref.compareCards;
  return {
    compareCards: compareCards
  };
};
/**
 * The mapDispatchToProps function dispatching actions to the store.
 */

var mapDispatchToProps = {
  saveToCompare: actions.saveToCompare,
  removeFromCompare: actions.removeFromCompare
};
export default connect(mapStateToProps, mapDispatchToProps)(KetoCompareCardCheckBox);
//# sourceMappingURL=keto-compare-card-checkbox.js.map